export class SessionExpiredException {
  public readonly message: string;

  public readonly name: string;

  constructor(message: string) {
    this.message = message;
    this.name = 'SessionExpiredException';
  }
}

export class RequestTerminatedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RequestTerminatedError';
  }
}

export class ModelTerminatedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ModelTerminatedError';
  }
}
